import "../assets/css/styles.table.css"
import Layout from './Layout.js';
import Box from '@mui/material/Box';
import Bindcomponent from '../utils/bindcomponent.js';
import { useEffect, useState } from "react";
import { useNavigate,useParams } from "react-router-dom";
import AxiosFetchData from "./AxiosFetchData";
import { CatchWrapperAsync } from "../utils/catchwrapper";
import Helper from "./Helper.js";
import Projectdetail from '../components/ProjectDetail.js';
const RequestMaterial = () =>{
    const navigate = useNavigate();
    const {id} = useParams()
    const [message,setmessage] = useState('')
    const [tipe,settipe] = useState('')
    const [rows,setRows] = useState([])
    const [roleAccess,setRoleAccess] = useState({})

    useEffect(()=>{
        fetch()
    },[])

    const fetch  =   () =>{
        CatchWrapperAsync(async()=>{
             const response = await AxiosFetchData.get(`GetMaterialRequest/${id}`).refreshToken(navigate,"requestmaterial",false)
             setRoleAccess(response.roleaccess)
             setRows(response.data.data.map((item, index)=>({
                ...item,
                rowNumber : index + 1
             })))
        },setmessage,settipe)
       
    }

    const columns = [
        { field: 'rowNumber', headerName: 'No.', width: 80 },
        { field: 'request_date', headerName: 'Request Date', width: 150 },
        { field: 'due_date', headerName: 'Due Date', width: 150},
        { field: 'descriptions', headerName: 'Descriptions', width: 500},
        
        {
          field: 'actions',
          headerName: 'Actions',
          width: 250,
          renderCell: (params) => (
            <>
            {/* <Bindcomponent component='ConfirmationButton' classname='btn btn-primary mr-2' text="Do you want approved this data?" type="button"  disabled={!roleAccess.UPDATE} onClick={async () => await handleStatus(params.row.id, 1)}>Edit</Bindcomponent>
            <Bindcomponent component='ConfirmationButton' classname='btn btn-danger mr-2' text="Do you want declined this data?" type="button" disabled={!roleAccess.READ}  onClick={async () => await handleDecline(params.row.id)}>Declined</Bindcomponent>
           */}
          <button disabled={!roleAccess.UPDATE}
                onClick={() =>
                               {
                                        navigate(`/RequestMaterialEdit/${params.row.id}/${id}${Helper.SetReturnUrl()}`)
                                         
                                } }  
                                      className="btn btn-info"
                                     
                                >
                                       Edit
        </button>
          
            </>
            
          ),
      },
      ];
    return (
        <>
            <Layout message={message} setmessage={setmessage} tipe={tipe} settipe={settipe}>
                <div className='pd'><b> REQUEST MATERIAL LIST</b></div>
                 
                <div className="pd">
                      <Projectdetail id={id} message={setmessage} tipe={settipe}></Projectdetail>
                    <button style={{marginBottom:10}}  disabled={!roleAccess.CREATE}
                        onClick={() =>
                               {
                                        navigate(`/RequestMaterialAdd/${id}${Helper.SetReturnUrl()}`)
                                         
                                } }  
                                      className="btn btn-primary"
                                     
                                >
                                       CREATE MATERIAL
                    </button>
                    <Box sx={{ width: 1 }} >
                    <Box sx={{ height: "100%" }} >
                        <Bindcomponent component='GridNumberPaging' customcolumns={columns} rows={rows} rowid={"id"} name="rakapprovalgrid" ></Bindcomponent>
                    </Box>
                    </Box>
                    
                </div>
            </Layout>
        </>
    )
}

export default RequestMaterial